import { render, staticRenderFns } from "./HeaderBurger.vue?vue&type=template&id=dbcfad46&scoped=true"
import script from "./HeaderBurger.vue?vue&type=script&lang=ts"
export * from "./HeaderBurger.vue?vue&type=script&lang=ts"
import style0 from "./HeaderBurger.vue?vue&type=style&index=0&id=dbcfad46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbcfad46",
  null
  
)

export default component.exports